/**
 * ChevronLeftIcon/index.js
 * desc: navigation back arrow
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ChevronLeftIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="chevron-left icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.chevronLeft.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 1.41L6 0 0 6l6 6 1.41-1.41L2.83 6l4.58-4.59z"/></svg>
    </IconButton>
);


export default ChevronLeftIcon;
